
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  @Component({
    mixins: [Proxyable],
  })
  export default class BaseMaterialWizard extends Vue {
    @Prop({type: Array, default: () => ({})}) private readonly availableSteps!: any[]
    @Prop({type: Array, default: () => ({})}) private readonly items!: any[]
  }
